<ng-container *ngIf="entries">

  <h3 *ngIf="coreEntries.length > 0">
    Integrated Project Team - Core Roles
  </h3>

  <section>

    <ng-container *ngFor="let entry of coreEntries">
      <digires-team-member-entry *ngIf="readOnly?.isReadOnly() ? !!entry.getUser() : !!entry.fg"
                                 [iptPhase]="iptPhase"
                                 [allUsers]="sortedUsers"
                                 [allRoles]="allRoles"
                                 [entry]="entry"
                                 [readOnly]="readOnly"
                                 [showCheckbox]="showCheckbox"
                                 (onDelete)="onDelete(entry)">
      </digires-team-member-entry>
    </ng-container>

  </section>

  <h3 *ngIf="widerEntries.length > 0">
    Integrated Project Team - Wider Roles
  </h3>

  <section>

    <ng-container *ngFor="let entry of widerEntries">
      <digires-team-member-entry *ngIf="readOnly?.isReadOnly() ? !!entry.getUser() : !!entry.fg"
                                 [iptPhase]="iptPhase"
                                 [allUsers]="sortedUsers"
                                 [allRoles]="allRoles"
                                 [entry]="entry"
                                 [readOnly]="readOnly"
                                 [showCheckbox]="showCheckbox"
                                 (onDelete)="onDelete(entry)">
      </digires-team-member-entry>
    </ng-container>

  </section>

  <ng-container *ngIf="canAdd && !readOnly?.isReadOnly()">
    <h3>Add a new Member</h3>

    <section class="row">

      <digires-user-input [formGroup]="newMemberEntry.fg"
                          class="team-member-add-input"
                          formCtrlName="user"
                          placeholder="New Team Member"
                          error="Please select a user for the new team member"
      ></digires-user-input>

      <digires-role-input [formGroup]="newMemberEntry.fg"
                          class="team-member-add-input"
                          [phase]="iptPhase"
                          formCtrlName="role"
                          placeholder="Role within Team"
                          error="Please select a role for the new team member"
      ></digires-role-input>

      <button mat-button type="button" class="btnPositive" [disabled]="isAddDisabled()" (click)="onAddEntry()">
        Add
        <mat-icon>add</mat-icon>
      </button>

      <mat-icon *ngIf="newMemberEntry.firstDuplicated || newMemberEntry.duplicated"
                matTooltip="Role already exists in Project.">
        content_copy
      </mat-icon>

    </section>
  </ng-container>

</ng-container>
